<template>
  <div class="login-container">
    <div class="login-form">
      <div class="card">
        <div class="card-header">
          <a href="#" class="logo-link">
            <img src="@/assets/img/logo_jtb.png" alt="Logo" />
          </a>
          <div class="text-login">{{ $t("general.system_name") }}</div>
        </div>
        <form @submit.prevent="handleSubmit">
          <div class="card-body">

            <div class="error-message" v-if="errorMessage">
              <div class="d-flex">
                  <div><i class="icon-warning mr-1"></i></div>
                  <div class="errror-txt">
                      <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                      <p class="fs-14 text-red font600" v-html=errorMessage></p>
                  </div>
              </div>
            </div>

            <div class="form-box">
              <div class="text-center mt-1">
                <!--テキスト-->
                <p class="font-weight-bold">
                  {{ $t("login.input_code_title") }}
                </p>
                <p>
                  {{ $t("login.input_code_message") }}
                </p>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:placeholder="$t('login.mfa_code')"
                    name="securityCode"
                    v-model="mfaCode"
                    v-validate="{ required: true, regex: /^[0-9]{6}$/ }"
                    maxlength="6"
                    :data-vv-as="$t('login.user_name')"
                  />
                </div>
              </div>

              <!--戻る次へボタン-->
              <div class="mt-3 d-flex">
                <div class="btn btn-gray-53 w-100" @click="back()">
                  {{ $t("button.back") }}
                </div>
                <button class="btn btn-pink-53 w-100 ml-3">
                  {{ $t("login.login") }}
                </button>
              </div>

              <p class="mt-3" style="text-align: center; font-size:14px">
                シークレットキーを再表示したい場合は<br>
                ワンタイムパスワードの設定をリセットする<br>
                必要があります。<br>
                <a :href="$t('chatbot.url')" target="_blank">証憑類電子化チャットボット</a>から<br>
                「STAPのワンタイムパスワードリセット」をご依頼ください。
              </p>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import Utils from "@/helpers/utils";
import { AuthService } from "@/services/common/auth.service";
import StorageService from "@/services/common/storage.service";
import { Role } from "@/helpers/role";

export default {
  name: "SpLoginMfa",
  data() {
    return {
      submitted: false,
      errorMessage: "",
      username: "",
      placeId: "",
      mfaCode: "",
      clickChangePass: false,
    };
  },

  beforeMount () {
      let token = StorageService.getToken();
      if (token) {
          const role = StorageService.getUserRole();
          if (role == Role.PwReset.id) {
              this.errorMessage = this.$root.$t("error.error_pwrest");
          } else {
              router.push("/");
          }
      }
      let remember = JSON.parse(StorageService.getRememberMe());
      if (remember) {
          this.username = remember.username;
          this.password = remember.password;
          //this.placeId = remember.placeId;
          this.rememberMe = remember.rememberMe;
      }
  },

  mounted() {
    this.username = this.$route.query.username;
    this.placeId = this.$route.query.placeId;
    this.clickChangePass = StorageService.getClickChangePass();
    let isExpired = StorageService.getExpired();
    if (isExpired) {
        this.errorMessage = this.$root.$t("error.error_expired");
        StorageService.removeExpired();
    }
  },

  methods: {
    back() {
      AuthService.doLogout();
    },

    handleSubmit(e) {
      this.errorMessage = "";
      this.submitted = true;
      this.$validator.validate().then(valid => {
          if (valid) {
            AuthService.mfaLogin(this.username, this.placeId, this.mfaCode, this.clickChangePass)
                .then(response => {
                    if (response.data) {
                        if (response.status != 200) {
                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                this.errorMessage = this.$root.$t("error.error_code_" + errorCode);
                            }
                        }
                    } else {
                        if (response.status == 400) {
                            this.errorMessage = this.$root.$t("login.error_400");
                        }
                        if (response.status == 403) {
                            this.errorMessage = this.$root.$t("login.error_403");
                        }
                        if (response.status == 404) {
                            this.errorMessage = this.$root.$t("login.error_404");
                        }
                    }
                })
                .catch(error => {
                    let isPWReset = StorageService.getSpLoginPwRest();
                    if (isPWReset) {
                        this.errorMessage = this.$root.$t("error.error_pwrest");
                        StorageService.removeSpLoginPwRest();
                    } else {
                        this.errorMessage = this.$root.$t("login.error_400");
                    }
                });
          }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Login/LoginMfa.vue